export default __webpack_public_path__ + "static/media/moneyControl.8911599f.svg";